export default "__VITE_ASSET__CK9wz9bj__"